import request from '@/utils/request';
// 登录
const login = params => {
    return request({
        url: `/auth/login`,
        data: params,
        method: 'post'
    });
};
// 获取验证码
const getCode = params => {
    return request({
        url: '/sys/captcha/img',
        method: 'get',
        params
    });
};
// 校验token有效性
const checkToken = params => {
    return request({
        url: `/auth/token/check`,
        method: 'get',
        params
    });
};
// 获取用户信息
const authInfo = () => {
    return request({
        url: '/auth/biz/user',
        method: 'get'
    });
};
// 获取管理人用户列表
const getUserList = params => {
    return request({
        url: '/auth/biz/user/list',
        method: 'get',
        params
    });
};
// 获取管理人用户列表数量
const getUserListNum = params => {
    return request({
        url: '/auth/biz/user/count',
        method: 'get',
        params
    });
};
// 添加用户
const addUser = params => {
    return request({
        url: `/auth/biz/user`,
        data: params,
        method: 'post'
    });
};
// 用户管理下的编辑用户
const editUser = (id, params) => {
    return request({
        url: `/auth/biz/user/${id}`,
        data: params,
        method: 'put'
    });
};
// 会议管理下的编辑用户
const editMeetingUser = (id, meetingId, params) => {
    return request({
        url: `/gathering/meeting/${meetingId}/invitee/creditor/${id}`,
        method: 'put',
        data: params
    });
};
// 启用/停用用户
const enablerOutUser = params => {
    return request({
        url: `/auth/biz/user/batch/ban`,
        method: 'put',
        data: params
    });
};
// 添加债权人
const addCreatorUser = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/creditor`,
        method: 'post',
        data: params
    });
};
// 会议管理下删除债权人
const deleteCreatorUser = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/batch`,
        method: 'delete',
        data: params
    });
};
// 用户管理下删除债权人
const deleteUser = params => {
    return request({
        url: `/auth/biz/user/batch/delete`,
        method: 'delete',
        data: params
    });
};
// 获取用户列表
const getCreatorUserList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/list`,
        method: 'get',
        params
    });
};
// 获取用户列表数量
const getUserCount = params => {
    return request({
        url: `/auth/biz/user/count`,
        method: 'get',
        params
    });
};
// 获取人员管理数量
const getCreatorCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/count`,
        params,
        method: 'get'
    });
};
// 导入债权人
const importCreatorUser = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/import`,
        data: params,
        method: 'post'
    });
};
// 查看导入进度
const importProgress = (meeting_id, id) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee/import/${id}`,
        method: 'get'
    });
};

// 下载
const meetingAuthGetFile = flowId => {
    return request({
        url: `/gathering/meeting_auth/get/file/${flowId}`,
        method: 'get'
    });
};
// 获取管理人短信数量
const getUserMsgCount = userId => {
    return request({
        url: `/gathering/lianlu/get_user_msg_count/${userId}`,
        method: 'get'
    });
};
// 设置管理人短信数量
const setUserMsgCount = (userId,msgCount) => {
    return request({
        url: `/gathering/lianlu/set_user_msg_count/${userId}/${msgCount}`,
        method: 'get'
    });
};
// 获取短信数量admin
const getBalance = userId => {
    return request({
        url: `/gathering/lianlu/get_balance`,
        method: 'get'
    });
};
// 获取短信验证码
const getSendPhoneLoginCode = phone => {
    return request({
        url: `/gathering/lianlu/send_phone_login_code/${phone}`,
        method: 'get'
    });
};
// 手机号码登录
const loginPhone = params => {
    return request({
        url: `/auth/login/phone`,
		data: params,
        method: 'post',
    });
};

// 添加其他人员
const addOther = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/other/add`,
        method: 'post',
        data: params
    });
};
// 删除其他人员
const delOther = (meeting_id, id) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee/other/del/${id}`,
        method: 'post',
    });
};
// 编辑其他人员
const editOther = (meeting_id, id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee/other/${id}`,
        method: 'put',
        data: params
    });
};
// 编辑代理人
const editAgent = (meeting_id, id, params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/invitee/agent/${id}`,
        method: 'put',
        data: params
    });
};

export {
	editAgent,
	editOther,
	delOther,
	addOther,
    meetingAuthGetFile,
    login,
    getCode,
    authInfo,
    addUser,
    editUser,
    getUserList,
    enablerOutUser,
    addCreatorUser,
    getCreatorUserList,
    getUserCount,
    editMeetingUser,
    deleteCreatorUser,
    deleteUser,
    getCreatorCount,
    importProgress,
    importCreatorUser,
    getUserListNum,
	getUserMsgCount,
	setUserMsgCount,
	getBalance,
	getSendPhoneLoginCode,
	loginPhone,
    checkToken
};
